<template>
    <div class="">
        <p class="mb-md-4 h5">1. Capture los siguientes datos:</p>
        <br>
        <form class="mx-auto" style="max-width: 40rem">
            <div class="form-inline mb-2">
                <div class="col-10">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <b-icon icon="search"></b-icon>
                            </div>
                        </div>
                        <input ref="txtnote" type="text" v-model="form.numdoc" class="form-control form-control-lg"
                               placeholder="1. Folio de nota de venta" required>
                    </div>
                </div>
                <div class="col-auto p-0">
                    <span class="h3 pointer-hover" @click="$bvModal.show('ayuda-folio-nota')">
                        <b-icon icon="question-circle" class="text-danger"></b-icon>
                    </span>
                </div>
            </div>
            <div class="form-inline mb-2">
                <div class="col-10">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <b-icon icon="file-richtext"></b-icon>
                            </div>
                        </div>
                        <input type="text" v-model="form.codfact" class="form-control form-control-lg"
                               placeholder="2. Código para facturar" required>
                    </div>
                </div>
                <div class="col-auto p-0">
                    <span class="h3 pointer-hover" @click="$bvModal.show('ayuda-codigo-facturar')">
                        <b-icon icon="question-circle" class="text-danger"></b-icon>
                    </span>
                </div>
            </div>
            <div class="col-10">
                <button class="btn btn-custom btn-block btn-lg" @click.prevent="login"><b>Siguiente</b></button>
            </div>
        </form>

        <b-modal id="ayuda-folio-nota" hide-footer centered>
            <template v-slot:modal-title>
                D&oacute;nde encontrar <code>Folio de nota</code>
            </template>
            <div class="d-block text-center">
                <img :src="getImgFolio()" class="img-fluid" alt="">
            </div>
        </b-modal>

        <b-modal id="ayuda-codigo-facturar" hide-footer centered>
            <template v-slot:modal-title>
                D&oacute;nde encontrar <code>C&oacute;digo para facturar</code>
            </template>
            <div class="d-block text-center">
                <img :src="getImgCodigo()" class="img-fluid" alt="">
            </div>
        </b-modal>
    </div>

</template>

<script>
    import getEnv from '../../../utils/env'
    export default {
        name: 'SearchNote',
        data() {
            return {
                form: {
                    numdoc: "",
                    codfact: "",
                }
            }
        },
        mounted() {
            this.$store.dispatch('note/clearAuth'); // en caso de regresarse y bucsar otra nota, se borra los datos guardados anteriormente
            this.$refs.txtnote.focus()
        },
        methods: {
            getImgCodigo(){
                return require('../../../assets/'+getEnv('VUE_APP_IMG_NOTA_CODIGO'))  
            } ,
            getImgFolio(){
                return require('../../../assets/'+getEnv('VUE_APP_IMG_NOTA_FOLIO'))  
            } ,
            login(e) {
                e.preventDefault();

                if (this.form.numdoc.trim() === "" || this.form.codfact.trim() === "") {
                    this.msgAlert("Por Favor llene los campos antes de continuar")
                    return
                }
                this.form.numdoc = this.form.numdoc.toLowerCase();

                this.$store.dispatch('note/loginAuth', this.form)
                    .then(() => {
                        this.$router.push({name: 'SearchClient'})
                    }).catch((error) => {
                    this.$store.dispatch('note/clearAuth');
                    if(error.response.data.error){
                        this.msgAlert(error.response.data.error);
                        console.log(error.response.data.error)
                    }else{
                        this.msgAlert(error.response.data.validations[0].error);
                        console.log(error.response.data.validations[0].error)
                    }
                });
            },

            msgAlert(err) {
                this.$bvModal.msgBoxOk(err, {
                    title: 'Advertencia, nota no encontrada',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                }).then(() => {
                    setTimeout(() => {
                        this.$refs.txtnote.focus()
                    }, 400);

                });
            }
        }
    }
</script>
<style>
    .pointer-hover:hover {
        cursor: pointer;
    }
</style>